<template>
  <v-list-item
    link
    :to="{name: to}"
    :disabled="disabled"
  >
    <v-list-item-action>
      <v-icon :class="color + '--text shadow ' + (variant ? 'text--' + variant : '')">
        {{ icon }}
      </v-icon>
      <v-badge
        v-if="noti_badge"
        dot
        color='red'
        class="bounce"
      ></v-badge>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title :class="color + '--text shadow ' + (variant ? 'text--' + variant : '')">
        <slot></slot>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    noti_badge: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
    },
    color: {
      type: String,
      default: "white",
    },
    variant: {
      type: String,
      default: "",
    },
    to: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
  .bounce {
    animation: pulse 1s infinite ease-in-out;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.4;
    }
    50% {
      transform: scale(2);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
</style>
